// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { xBaseTheme } from "@flip/XDL/types";
import { color, ellipsis } from "@flip/XDL/Utilities";
import { FormFieldClickable, FormFieldIcon } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

export const PlaceholderSelector = `
        &::placeholder,
        &::-webkit-input-placeholder
`;

export const placeholderStyle = css`
    ${PlaceholderSelector} {
        font-size: 14px;
        font-style: italic;
        letter-spacing: 0;
        line-height: 16px !important;
        max-width: 100%;
        color: ${color("common.ui4")};
        font-family: ${fontConfig.fontFamily};
        font-weight: ${fontConfig.weight.regular};
    }
`;

export default {
    defaultProps: {
        border: "rounded",
        sizeVariant: "default",
        backgroundColor: "common.white",
        labelProps: {
            mergeCss: true,
            size: 12,
            transform: "capitalize",
            weight: fontConfig.weight.regular,
            color: "text",
            css: css`
                min-height: initial;
                letter-spacing: 0;
                line-height: 13px;
            `,
        },
        errorProps: {
            mergeCss: true,
            size: 14,
            weight: fontConfig.weight.regular,
            color: "text",
            css: css`
                min-height: initial;
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                input,
                select {
                    &:not(.react-datetime-picker__inputGroup__input) {
                        ${ellipsis(1)}
                        text-overflow: ellipsis;
                        ${placeholderStyle}
                        &:not(:disabled):hover {
                            border: 1px solid ${color("common.ui13")};
                        }
                    }
                }

                textarea {
                    ${placeholderStyle}
                    &:not(:disabled):hover {
                        border: 1px solid ${color("common.ui13")};
                    }
                }
                select[aria-expanded="true"] + ${IconWrapper} svg {
                    transform: rotate(180deg);
                }

                input[type="number"] {
                    &::-webkit-inner-spin-button,
                    &::-webkit-outer-spin-button {
                        -webkit-appearance: none;
                        appearance: none;
                        margin: 0;
                    }
                }
            `,
        },
    },
} as xBaseTheme["formField"];
